import { AttachmentItemDto } from '@/api/generated';

export type NewEmailAttachmentModel = Omit<
  AttachmentItemDto,
  'attachmentId' | 'externalAttachmentId'
> & {
  attachmentId?: string;
  externalAttachmentId?: string;
  isReady: boolean;
  uuid: UUID;
};

export type NewEmailUpdateAttachmentModel = {
  attachmentId: string;
  name?: string;
  uuid: UUID;
};

export type UUID = ReturnType<typeof crypto.randomUUID>;

export const mapAttachmentItemToNewEmailAttachment = (
  attachment: AttachmentItemDto,
  isReady: boolean,
): NewEmailAttachmentModel => ({
  ...attachment,
  isReady,
  uuid: crypto.randomUUID(),
});
